import { TableConfig } from '@constants/table.constants';
import { GridSortItem } from '@mui/x-data-grid';
import { createStore, withProps } from '@ngneat/elf';
import { withEntities, withUIEntities } from '@ngneat/elf-entities';
import { withPagination } from '@ngneat/elf-pagination';
import { withRequestsStatus } from '@ngneat/elf-requests';
import { TablePagination } from '@store/common/pagination.model';
import { AuditsFilters } from '../audits.model';
import { Templates, TemplatesFilters, TemplatesUI } from './templates.model';


export interface TemplatesState {
  filters: TemplatesFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const templatesStore = createStore(
  { name: 'templates' },
  withProps<TemplatesState>({
    filters: { search: '', tableFilters: AuditsFilters.initTableFilters() },
    sort: {
      field: 'createdAt',
      sort: 'desc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<Templates>(),
  withUIEntities<TemplatesUI>(),
  withPagination(),
  withRequestsStatus()
);
